import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class Contacts extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M10,16.5c0,0-0.2,0-0.2-0.5c0-0.3,0-0.7,0-0.9c1.3-1.2,1.9-3.2,1.9-4.8V8.2c0-1.2-0.5-2.2-1.2-3c-0.1-0.1-0.3-0.2-0.4-0.3
                    C9.9,4.8,9.8,4.7,9.6,4.6C9,4.2,8.2,4,7.4,4H7.3C5,4,3.1,5.9,3.1,8.2v2.1c0,0.4,0,0.8,0.1,1.2c0,0.2,0.1,0.4,0.2,0.6
                    C3.6,13,4,13.8,4.6,14.5C4.7,14.7,4.9,14.8,5,15c0,0.2,0,0.7,0,1c0,0.5-0.2,0.5-0.2,0.5s-4.2,2.4-4.2,2.4c0,0-0.2,0.1-0.2,0.1h0
                    C0.2,19.3,0,19.5,0,19.8v0C0,20.5,0.7,21,1.5,21h11.9c0.7,0,1.3-0.4,1.5-0.9c0-0.1,0-0.2,0-0.2v0c0-0.2-0.1-0.4-0.2-0.6
                    c0-0.1-0.1-0.1-0.2-0.2l0,0l0,0C14.5,19,10,16.5,10,16.5z"
                />
                <path
                    d="M23.7,15.9L23.7,15.9L23.7,15.9c-0.2-0.2-4.1-2-4.1-2s-0.2,0-0.2-0.4c0-0.3,0-0.4,0-0.6c1-0.9,1.5-2.5,1.5-3.8V7.4
                    C21,5.5,19.4,4,17.6,4h-0.1c-1.9,0-3.4,1.5-3.4,3.4v1.7c0,1.2,0.5,2.8,1.5,3.7c0,0.2,0,0.3,0,0.6c0,0.4-0.2,0.4-0.2,0.4
                    s-0.9,0.6-2.2,1.3c-0.4,0.2-0.4,0.7,0,0.9c0.8,0.4,1.8,1,2.6,1.3c0.2,0.1,0.4,0.1,0.6,0.1H23c0.7,0,1-0.4,1-0.9v0
                    C24,16.3,23.9,16,23.7,15.9z"
                />
            </SvgIcon>
        );
    }
}

export default Contacts;
